import { useMemo, useEffect, useState, useRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
import {
  useTable,
  usePagination,
  useGlobalFilter,
  // useAsyncDebounce,
  useSortBy,
} from "react-table";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDPagination from "../../../components/MDPagination";

// Material Dashboard 2 React example components
import DataTableHeadCell from "../../../examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "../../../examples/Tables/DataTable/DataTableBodyCell";
import { getCountryList } from "../../../actions/country";
import { useDispatch } from "react-redux";
import { get as _get, isEqual as _isEqual } from "lodash";
import { getUserList } from "../../../actions/user";
import { getDeletedUsersList } from "../../../actions/deleteUser";
import { getHoodsList } from "../../../actions/hoods";
import { getAdminList } from "../../../actions/adminUser";
import { getPlacesTableList } from "../../../actions/places";
import { getLabelLanguageList } from "../../../actions/labelLanguage";
import { getPostsList } from "../../../actions/posts";
import { Radio } from "@material-ui/core";
function DataTable({
  entriesPerPage,
  canSearch,
  canFilter,
  categoryCode,
  showTotalEntries,
  table,
  pagination,
  isSorted,
  noEndBorder,
  totalRecords,
  pageIndex1,
  pageSize1,
  tableFor,
}) {
  const defaultValue = entriesPerPage.defaultValue
    ? entriesPerPage.defaultValue
    : 30;
  const entries = entriesPerPage.entries
    ? entriesPerPage.entries.map((el) => el.toString())
    : ["5", "10", "15", "20", "25"];
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);


  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: pageIndex1,
        pageSize: pageSize1,
      },
      pageCount: Math.ceil(totalRecords / defaultValue),
      manualPagination: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    // setGlobalFilter,
    // pageCount,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // Set the default value for the entries per page when component mounts
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

  // Set the entries per page value based on the select value
  const setEntriesPerPage = (value) => setPageSize(value);

  // Render the paginations

  const renderPagination = pageOptions.map((option) => (
    <MDPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </MDPagination>
  ));

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0
      ? gotoPage(0)
      : gotoPage(Number(value));

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) =>
    gotoPage(Number(value.value - 1));

  // Search input value state
  const [search, setSearch] = useState(globalFilter);

  // Search input state handle
  // const onSearchChange = useAsyncDebounce((value) => {
  //   // setGlobalFilter(value || undefined);
  // }, 100);

  const onSearchChange = (value) => {
    if(_isEqual(tableFor, "adminList")) {
      dispatch(getAdminList(pageIndex, pageSize, value))
    } else if (_isEqual(tableFor, "appUserList")) {
      dispatch(getUserList(pageIndex, pageSize, value));
    } 
    else if (_isEqual(tableFor, "deletedUserList")) {
      dispatch(getDeletedUsersList(pageIndex, pageSize, value));
    }
    else if(_isEqual(tableFor,"postsList")){
      dispatch(getPostsList(pageIndex, pageSize, value))
    }
    else if (_isEqual(tableFor, "countryList")) {
      dispatch(getCountryList(pageIndex, pageSize, value));
    } else if (_isEqual(tableFor, "hoodsList")) {
      dispatch(getHoodsList(pageIndex, pageSize, value, categoryCode))
    } else if (_isEqual(tableFor, "placesList")) { 
      dispatch(getPlacesTableList(pageIndex,pageSize,value,categoryCode))
    } else if (_isEqual(tableFor, "labelLanguageList")) {
      dispatch(getLabelLanguageList(pageIndex, pageSize, value));
    } 
  }

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  // Setting the entries starting point
  const entriesStart =
    pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

  // Setting the entries ending point
  let entriesEnd = totalRecords;

  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === pageOptions.length - 1) {
    entriesEnd = totalRecords;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }

  const prevRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (_isEqual(tableFor, "countryList")) {
      dispatch(getCountryList(pageIndex, pageSize, search));
    } else if (_isEqual(tableFor, "appUserList")) {
      console.warn("appUserList",search)
      dispatch(getUserList(pageIndex, pageSize, search));
    }else if (_isEqual(tableFor, "deletedUserList")) {
      dispatch(getDeletedUsersList(pageIndex, pageSize, search));
    }else if(_isEqual(tableFor,"postsList")){
      dispatch(getPostsList(pageIndex, pageSize, search))
    }else if (_isEqual(tableFor, "hoodsList")) {
      dispatch(getHoodsList(pageIndex, pageSize, search,categoryCode))
    } else if(_isEqual(tableFor, "adminList")) {
      dispatch(getAdminList(pageIndex, pageSize, search))
    } else if (_isEqual(tableFor, "placesList")) { 
      dispatch(getPlacesTableList(pageIndex,pageSize,search,categoryCode))
    } else if (_isEqual(tableFor, "labelLanguageList")) {
      dispatch(getLabelLanguageList(pageIndex, pageSize, search));
    } 
    prevRef.current = { pageIndex, pageSize };
  }, [dispatch, pageIndex, pageSize, tableFor]);

  const loading =
    rows.length === 0 ||
    _get(prevRef, "current.pageIndex", 0) !== pageIndex ||
    _get(prevRef, "current.pageSize", 20) !== pageSize;

  console.log("check loading ::", loading);

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      {entriesPerPage || canSearch ? (
        <MDBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          p={2}
        >
     {/*      {entriesPerPage && (
            <MDBox display="flex" alignItems="center"> */}
                   {canSearch && (
            <MDBox width="15rem" ml={2} >
              <MDInput
                placeholder="Search..."
                variant="outlined"
                value={search}
                size="regular"
                fullWidth
                
                onChange={(event) => {
                  setSearch(event.target.value);
                  onSearchChange(event.target.value);
                }}
                
                // sx={({ palette: { grey }, borders: { borderWidth }, size }) => ({
                //   border: `${borderWidth[1]} solid ${grey[300]}`,
                //     variant: "contained",
                //     borderRadius: "0.375rem",
                //     size: "16px",
                // })}
                
              ></MDInput>
            {/*    <Autocomplete
                disableClearable
                value={pageSize.toString()}
                options={entries}
                onChange={(event, newValue) => {
                  setEntriesPerPage(parseInt(newValue, 10));
                }}
                size="small"
                sx={{ width: "5rem" }}
                renderInput={(params) => <MDInput {...params} />}
              /> */}
        
            </MDBox>
          )}
         {/*  {canSearch && (
            <MDBox width="15rem"  ml="auto" >
              <MDInput
                placeholder="Search..."
                value={search}
                size="small"
                fullWidth
                onChange={(event) => {
                  setSearch(event.target.value);
                  onSearchChange(event.target.value);
                }}
              />
            </MDBox> */}
        </MDBox>
      ) : null}
      <Table {...getTableProps()}>
        {loading ? (
          <MDBox textAlign={"center"} p={10}>
            Loading...
          </MDBox>
        ) : (
          <>
            <MDBox component="thead">
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <DataTableHeadCell
                      {...column.getHeaderProps(
                        isSorted && column.getSortByToggleProps()
                      )}
                      width={column.width ? column.width : "auto"}
                      align={column.align ? column.align : "left"}
                      sorted={setSortedValue(column)}
                      disableSortBy={column.disableSortBy}
                      isSortedDesc= {column.isSortedDesc}
                    >
                      {column.render("Header")}
                    </DataTableHeadCell>
                  ))}
                </TableRow>
              ))}
            </MDBox>
            <TableBody {...getTableBodyProps()}>
              {page.map((row, key) => {
                prepareRow(row);
                return (
                  <TableRow
                    key={key}
                    // onClick={() => navigate("/user/details")}
                    // sx={{cursor: "pointer"}}
                    {...row.getRowProps()}
                  >
                    {row.cells.map((cell) => (
                      <DataTableBodyCell
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </DataTableBodyCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        )}
      </Table>

      <MDBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
        py={1}
        px={2}
        sx={({ palette: { grey },  borders: { borderWidth } }) => ({
          borderTop: `${borderWidth[1]} solid ${grey[200]}`,
        })}
      >
        {showTotalEntries && (
          <MDBox mb={{ xs: 3, sm: 0 }}>
            <MDTypography
              variant="button"
              color="secondary"
              fontWeight="regular"
            >
              Showing {entriesStart} to {entriesEnd} of {totalRecords} entries
            </MDTypography>
          </MDBox>
        )}
        {pageOptions.length > 1 && (
          <MDPagination
            variant={pagination.variant ? pagination.variant : "gradient"}
            color={pagination.color ? pagination.color : "info"}
          >
            {canPreviousPage && (
              <MDPagination item onClick={() => previousPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
              </MDPagination>
            )}
            {renderPagination.length > 6 ? (
              <MDBox width="5rem" mx={1}>
                <MDInput
                  inputProps={{
                    type: "number",
                    min: 1,
                    max: customizedPageOptions.length,
                  }}
                  value={customizedPageOptions[pageIndex]}
                  onChange={(handleInputPagination, handleInputPaginationValue)}
                />
              </MDBox>
            ) : (
              renderPagination
            )}
            {canNextPage && (
              <MDPagination item onClick={() => nextPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
              </MDPagination>
            )}
          </MDPagination>
        )}
      </MDBox>
    </TableContainer>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 30, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  canFilter: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "purple" },
  isSorted: true,
  noEndBorder: false,
  totalRecords: 0,
  pageIndex1: 0,
  pageSize1: 30,
  tableFor: "",
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  canFilter: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
  totalRecords: PropTypes.number,
  pageIndex1: PropTypes.number,
  pageSize1: PropTypes.number,
  tableFor: PropTypes.string,
  categoryCode: PropTypes.string,
};

export default DataTable;
